import { CancellationState } from 'lib/graphql';
import { getBookingCancellationQuotePageLink } from 'lib/links';
import getStageSuffix from '../getStageSuffix';

const getPathNameForStage = (bookingId: string, stage: CancellationState, error?: Error) => {
  const suffix = getStageSuffix(stage, error);

  return getBookingCancellationQuotePageLink(bookingId, suffix);
};

export default getPathNameForStage;
